import axios from 'axios';
import { enqueueSnackbar } from 'notistack';

export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response) {
        enqueueSnackbar('Server is unreachable. Please try again later.');
        return Promise.reject(error);
      }

      return Promise.reject(error);
    }
  );
};